export default "__VITE_ASSET__b5191c43__"